export default {
	name : "header",
    _id: "header",
    _selector: "header",

    init() {
		
    },
};
